import { render } from "./pricingpage.vue?vue&type=template&id=81656570&scoped=true"
import script from "./pricingpage.vue?vue&type=script&lang=js"
export * from "./pricingpage.vue?vue&type=script&lang=js"

import "./pricingpage.vue?vue&type=style&index=0&id=81656570&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81656570"]])

export default __exports__